<template>
  <DxPopup @hidden="onHidden" :visible="showPop" :show-close-button="true" :show-title="true" :title="'Testing...'" height="700px" width="1000px">
    jdePop
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';

export default {
  props: {
    showPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  components: {
    DxPopup
  },
  data() {
    return {

    }
  },
  methods: {
    onHidden(e) {
      this.$emit('update:showPop', false)
    }
  },
}
</script>

<style lang="scss" scoped>

</style>